var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:([_vm.containerStyle, _vm.customStyle])},[(_vm.src)?[_c('img',{style:(_vm.style),attrs:{"src":_vm.src}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }